export const VIEWS = {
  HOUSE_BOARD: 'DefaultView',
  NOTIFICATION: 'NotificationView'
}
